import { useEffect } from 'react';
import useMainStore from '../../../store/mainState';

const Toast = () => {
    const { toast, clearToast } = useMainStore();

    useEffect(() => {
        if (!toast) return;
        const timer = setTimeout(() => clearToast(), 4000);
        return () => clearTimeout(timer);
    }, [toast, clearToast]);

    if (!toast) return null;

    const colors =
        toast.type === 'success'
            ? { bg: 'rgba(16, 185, 129, 0.15)', border: 'rgba(16, 185, 129, 0.4)', text: '#10b981' }
            : toast.type === 'info'
            ? { bg: 'rgba(0, 134, 211, 0.15)', border: 'rgba(0, 134, 211, 0.4)', text: '#4DBDFF' }
            : { bg: 'rgba(239, 68, 68, 0.15)', border: 'rgba(239, 68, 68, 0.4)', text: '#ef4444' };

    return (
        <div
            className="fixed top-[20px] left-1/2 -translate-x-1/2 z-[9999] px-[20px] py-[12px] rounded-[12px] backdrop-blur-md flex items-center gap-[10px] animate-[toastIn_0.3s_ease-out]"
            style={{
                background: colors.bg,
                border: `1px solid ${colors.border}`,
                boxShadow: '0 8px 32px rgba(0, 0, 0, 0.4)',
                maxWidth: '90vw',
            }}
        >
            <p className="text-white text-[14px] font-medium" style={{ color: colors.text }}>
                {toast.message}
            </p>
            <button
                onClick={clearToast}
                className="text-white/60 hover:text-white text-[18px] leading-none"
                aria-label="Close"
            >
                ×
            </button>
            <style>{`
                @keyframes toastIn {
                    0% { opacity: 0; transform: translate(-50%, -20px); }
                    100% { opacity: 1; transform: translate(-50%, 0); }
                }
            `}</style>
        </div>
    );
};

export default Toast;
